import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Rating from "@mui/material/Rating";

import img from "../../assets/../src/assets/all-courses2.svg";
import GetCourses from "../actions/GetCourses";
import PriceFormat from "../actions/PriceFormat";
import DetectDevice from "../data/DetectDevice";
import { IconButton } from "@mui/material";
import { Search } from "@mui/icons-material";
import { X } from "lucide-react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const OnlineCoursesLyfax = () => {
  const location = useLocation();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false); // 👈 NEW
  const device = DetectDevice();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchCourses();
    console.log(location.pathname, "use params working"); // ✅ use directly
  }, []);

  const handleViewAll = () => {
    setSearchTerm(""); // Clear search term
    // setActiveCategory("All"); // Reset category to All
  };

  const fetchCourses = async () => {
    try {
      const res = await GetCourses({
        payload: {
          mode: "live",
          limit: 50,
          device: device === "mobile" ? "mobile" : "desktop",
        },
      });
      setCourses(res || []);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  // 👇 ONLY 2 ROWS (6 COURSES) INITIALLY
  const visibleCourses = showAll ? courses : courses.slice(0, 6);

  return (
    <div className="container py-3">
      <div className="text-center mb-4">
        <h2 className="fw-bold clr-siliconMinds-orng" style={{ fontSize: "2.5rem" }}>
          {" "}
          Our Courses
        </h2>
        <p
          className="fs-5 mx-lg-5 mx-md-4 mx-sm-0 d-sm-none d-md-none d-lg-block"
          style={{ margin: "0 auto", color: "#4a4e5b" }}
        >
          Discover courses to gain new skills, advance your career, and stay
          competitive in today's fast-paced world. Use the search bar or browse
          all to find your perfect course.
        </p>
      </div>
      <div className="mb-5 d-flex justify-content-center align-items-center gap-3 flex-wrap">
        <div
          className="search-bar-wrapper position-relative flex-grow-1"
          style={{ maxWidth: "500px" }}
        >
          <Search
            size={20}
            className="search-icon position-absolute text-muted"
            style={{ left: "16px", top: "50%", transform: "translateY(-50%)" }}
          />
          <input
            type="text"
            className="form-control ps-5 pe-5 rounded-pill border-0"
            style={{
              height: "48px",
              background: "rgba(255, 255, 255, 0.95)",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              fontSize: "15px",
            }}
            placeholder="Search courses "
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <IconButton
              className="clear-icon position-absolute"
              onClick={() => setSearchTerm("")}
              size="small"
              style={{
                right: "8px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              <X size={18} className="text-muted" />
            </IconButton>
          )}
        </div>
        {!location.pathname.startsWith("/course") && (
          <Link
            to="/courses"
            style={{
              width: "120px",
              height: "48px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: "linear-gradient(135deg, #ff7a18, #ffb347)",
              color: "white",
              border: "none",
              fontWeight: "600",
              boxShadow: "0 4px 12px rgba(255, 122, 24, 0.3)",
              cursor: "pointer",
            }}
            className="btn view-all-btn rounded-pill"
            onClick={handleViewAll}
          >
            View All
          </Link>
        )}

      </div>

      {loading ? (
        <p className="text-center">Loading courses...</p>
      ) : (
        <>
          <div className="row">
            {visibleCourses
              .filter((course) =>
                course.course_title
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase()),
              )
              .map((course, index) => (
                <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <Link
                    to={"/course/" + course.course_url + "/" + course.mode}
                    className="text-decoration-none"
                  >
                    <div className="ly-card">
                      {/* IMAGE */}
                      <div className="ly-img">
                        <img
                          src={course.course_cover_url || img}
                          alt={course.course_title}
                        />
                        <span
                          className={`ly-badge ${course.mode === "live" ? "live" : "self"
                            }`}
                        >
                          {course.mode === "live" ? "LIVE" : "SELFPACED"}
                        </span>
                      </div>

                      {/* BODY */}
                      <div className="ly-body">
                        <Rating value={course.rating} readOnly size="small" />

                        <h5 className="ly-title">{course.course_title.slice(0,38)}{course.course_title.length>39? "...":null}</h5>

                        <p className="ly-enrolled">
                          {course.course_students} Enrolled
                        </p>

                        <div className="ly-price-row">
                          {/* <span className="ly-price">
                            {PriceFormat(course.course_price)}
                          </span>
                          <del>{PriceFormat(course.course_cutoff_price)}</del> */}
                          <span className="ly-seats">
                            {course.seats_left} seats left
                          </span>
                        </div>

                        <button className="ly-btn">🎓 View More</button>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
          </div>

          {/* 👇 VIEW MORE / VIEW LESS */}
          {courses.length > 6 && (
            <div className="text-center mt-4">
              <button
                className="view-more-btn"
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? "View Less" : "View More"}
              </button>
            </div>
          )}
        </>
      )}

      {/* EXACT LYFAX STYLE */}
      <style>{`
        .ly-card {
          background: #fff;
          border-radius: 18px;
          box-shadow: 0 10px 28px rgba(0,0,0,0.08);
          overflow: hidden;
          transition: all .25s ease;
        }

        .ly-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.12);
        }

        .ly-img {
          position: relative;
          height: 200px;
        }

        .ly-img img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .ly-badge {
          position: absolute;
          bottom: 12px;
          left: 12px;
          padding: 6px 14px;
          font-size: 13px;
          font-weight: 600;
          border-radius: 8px;
          color: #fff;
        }

        .ly-badge.self {
          background: #1e40af;
        }

        .ly-badge.live {
          background: #ef4444;
        }

        .ly-body {
          padding: 16px;
        }

        .ly-title {
          font-size: 18px;
          font-weight: 600;
          margin: 8px 0;
          color: #111827;
        }

        .ly-enrolled {
          font-size: 14px;
          color: #6b7280;
          margin-bottom: 10px;
        }

        .ly-price-row {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 14px;
        }

        .ly-price {
          font-size: 18px;
          font-weight: 700;
          color: #15803d;
        }

        .ly-price-row del {
          color: #9ca3af;
        }

        .ly-seats {
          margin-left: auto;
          font-size: 14px;
          color: #dc2626;
        }

        .ly-btn {
          width: 100%;
          padding: 12px;
          border-radius: 12px;
          border: none;
          font-weight: 600;
          background: linear-gradient(135deg, rgb(251, 140, 0), rgb(244, 81, 30)) !important;
          color: #fff;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          text-align: center;
        }

        .ly-btn:hover {
          opacity: .9;
          transform: translateY(-1px);
        }

        .view-more-btn {
          padding: 10px 28px;
          border-radius: 999px;
          border: none;
          font-weight: 600;
          background: linear-gradient(135deg, rgb(251, 140, 0), rgb(244, 81, 30)) !important;
          color: #fff;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(255, 122, 24, 0.3);
          transition: all 0.2s ease;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          text-align: center;
        }

        .view-more-btn:hover {
          opacity: 0.9;
          transform: translateY(-1px);
        }

        @media(max-width:576px){
          .ly-img {
            height: 180px;
          }
        }
      `}</style>
    </div>
  );
};

export default OnlineCoursesLyfax;
